export default __webpack_public_path__ + "static/media/Påklædning_sikkerhedsudstyr.b6a1eec9.mp4";